export default __webpack_public_path__ + "static/media/330_business01-nl-mobile.968ab8d5.png";